import Link from "next/link";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { useRecoilState } from "recoil";
import { motion } from "framer-motion";

import { engageUpcomingMeetings } from "../../atoms/engage";
import { apiGetUpcoming } from "../../lib/api/engage";

import { ChevronRightIcon } from "@heroicons/react/solid";

import MonthView from "../Calendar/MonthView";
import MobileList from "./MobileList";

const Landing = () => {
  const router = useRouter();
  const { client } = router.query;
  const [upcomingList, setUpcomingList] = useRecoilState(
    engageUpcomingMeetings
  );

  useEffect(() => {
    if (client) {
      async function fetchData() {
        const upcoming = await apiGetUpcoming(client);
        setUpcomingList(upcoming);
      }
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  return (
    <div className="grid grid-cols-1 2xl:grid-cols-4 gap-2">
      {/* Calendar */}
      <div className="lg:col-span-4 hidden md:block">
        <MonthView client={client} />
      </div>
      <div className="md:hidden">
        <MobileList client={client} />
      </div>

      {/* Right Side */}
      <div className="hidden py-4 md:flex flex-col space-y-4 lg:space-y-6 lg:mt-4 lg:px-2 lg:col-span-2">
        {/* Latest Posting */}
        {/* Agendas */}
        <div>
          <p className="xl:text-lg 2xl:text-xl font-semibold pb-2 text-black text-center">
            Recently Posted Agendas
          </p>
          <div className="">
            {upcomingList?.length === 0 && (
              <p className="italic text-gray-800 text-xs 2xl:text-base">
                There are no new posted agendas this month.
              </p>
            )}
            {upcomingList?.map((agenda) => {
              if (agenda.publishStatus === "published") {
                return (
                  <motion.div
                    key={agenda.id}
                    className="relative rounded-lg border-2 border-gray-500/20 bg-white px-3 2xl:px-6 py-3 shadow-sm flex items-center space-x-3 cursor-pointer mb-2"
                    whileHover={{
                      scale: 1.03,
                      transition: { duration: 0.3 },
                    }}
                  >
                    <Link
                      href="/engage/[client]/[agenda]"
                      as={`/engage/${client}/${agenda.id}`}
                    >
                      <a className="flex justify-between items-center w-full">
                        <div className="focus:outline-none">
                          <span
                            className="absolute inset-0"
                            aria-hidden="true"
                          />
                          <p className="text-sm xl:text-base hd:text-lg font-semibold text-gray-900">
                            {agenda.department?.name}
                          </p>
                          <p className="text-[11px] xl:text-xs hd:text-base text-gray-700 font-medium">
                            {agenda.scheduleDate}
                          </p>
                        </div>
                        <div>
                          <ChevronRightIcon
                            className="w-5 h-5 2xl:h-7 2xl:w-7 text-gray-900"
                            aria-hidden="true"
                          />
                        </div>
                      </a>
                    </Link>
                  </motion.div>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
